import cn from "classnames";
import { VesselModel } from "entities/SeaSearchCard";
import { resolveDateValues } from "entities/shared/utils";
import { useTranslation } from "shared/localization/localization";
import { VesselRow } from "./VesselRow";
import styles from "./VesselList.module.scss";

type VesselProps = {
  className?: string;
  vessel: VesselModel;
};

export const Vessel: RFC<VesselProps> = ({ vessel, className }) => {
  const { t } = useTranslation();
  const { name, voyage, pol, pod, atd, etd, ata, eta, predictiveETA } = vessel;
  const { departureDate, arrivalDate } = resolveDateValues({
    atd,
    etd,
    ata,
    eta,
    formatedDate: true,
    useValuePlaceholder: true,
    predictiveETA,
  });

  return (
    <div className={cn(styles.vessel, className)}>
      <VesselRow title={t("Vessel")} value={name} />
      <VesselRow title={t("Voyage")} value={voyage} />
      <VesselRow title={t("Loading")} value={pol} />
      <VesselRow title={t("Discharge")} value={pod} />
      <VesselRow title={departureDate.unit} value={departureDate.value} />
      <VesselRow title={arrivalDate.unit} value={arrivalDate.value} />
    </div>
  );
};
